export const buildPath = (value: string) =>
  value
    .replaceAll(' ', '-')
    .replace(/[^a-zA-Z|\-_\d+]/g, '')
    .toLowerCase()
